import React from 'react';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const getBreadcrumbName = (pathname, t) => {
  const routes = {
    '/dashboard': t('nav.dashboard'),
    '/hospitals': t('nav.hospitals'),
    '/devices': t('nav.devices'),
    '/equipment': t('nav.equipment'),
    '/suppliers': t('nav.suppliers'),
    '/barriers': t('nav.barriers'),
    '/equipment-barriers': t('nav.equipmentBarriers'),
    '/users': t('nav.users'),
    '/alerts': t('nav.alerts'),
    '/alarms': t('nav.alarms'),
    '/analytics': t('nav.analytics'),
    '/patient-tracking': t('nav.patientTracking'),
    '/staff-tracking': t('nav.staffTracking'),
    '/zone-management': t('nav.zoneManagement'),
    '/interactive-maps': t('nav.interactiveMaps'),
    '/asset-tracking': t('nav.assetTracking'),
    '/audit-logs': t('nav.auditLogs'),
  };
  
  return routes[pathname] || pathname.split('/').pop();
};

const Breadcrumb = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  
  const pathnames = location.pathname.split('/').filter((x) => x);
  
  if (pathnames.length === 0 || location.pathname === '/dashboard') {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Link
          underline="hover"
          color="inherit"
          onClick={() => navigate('/dashboard')}
          sx={{ cursor: 'pointer' }}
        >
          {t('nav.dashboard')}
        </Link>
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const name = getBreadcrumbName(to, t);

          return last ? (
            <Typography color="text.primary" key={to}>
              {name}
            </Typography>
          ) : (
            <Link
              underline="hover"
              color="inherit"
              onClick={() => navigate(to)}
              key={to}
              sx={{ cursor: 'pointer' }}
            >
              {name}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;